import { Record, List } from 'immutable';
import { tFunctionType } from 'app/components/localization';

export enum StatusFilterId {
  ProfileCompleted = 'profile_completed',
  EmailConfirmed = 'confirmed',
}

// Implements Dropdown protocol
export class UserStatusFilter<Id extends StatusFilterId> {
  public constructor(
    public readonly id: Id,
    public readonly getName: (t: tFunctionType) => string,
  ) {}
}

export const PROFILE_COMPLETED = new UserStatusFilter(
  StatusFilterId.ProfileCompleted,
  (t) => t('admin.users.user-status.profile-completed'),
);

export const EMAIL_CONFIRMED = new UserStatusFilter(
  StatusFilterId.EmailConfirmed,
  (t) => t('admin.users.user-status.confirmed'),
);

export class UserFilterQuery extends Record<{ [K in StatusFilterId]: boolean | undefined }>({
  confirmed:         undefined,
  profile_completed: undefined,
}) {}

export const USER_STATUS_FILTERS = List([PROFILE_COMPLETED, EMAIL_CONFIRMED]);

export const USER_STATUS_FILTERS_MAP: { [Id in StatusFilterId]: UserStatusFilter<Id> } = {
  [StatusFilterId.EmailConfirmed]: EMAIL_CONFIRMED,
  [StatusFilterId.ProfileCompleted]: PROFILE_COMPLETED,
};
